import { getGlobals, getToken } from '@/lib/globals';
import type {
  AuthflowRedirectInputElements,
  GoToAuthflowParams,
} from './types';

/** Adds a hidden form and submits it for internal redirect */
export const goToAuthflow = ({
  accessToken,
  redirectUrl,
  contingencyType,
}: GoToAuthflowParams): void => {
  const {
    noCookie: { nsid, _csrf },
  } = getGlobals();

  if (!_csrf) {
    throw new Error('No csrf was found in globals');
  }
  if (!nsid) {
    throw new Error('No nsid was found in globals');
  }

  const form = document.createElement('form');

  form.method = 'POST';
  form.action = `/checkoutweb/stepup?token=${getToken()}`;
  form.style.display = 'none;';

  const inputs: AuthflowRedirectInputElements = {
    _csrf: _csrf,
    accessToken: accessToken,
    contingencyType: contingencyType,
    nsid: nsid,
    redirectUrl: redirectUrl,
  };

  Object.keys(inputs).forEach(key => {
    const input = document.createElement('input');
    input.name = key;
    input.value = inputs[key];
    input.type = 'hidden';
    form.appendChild(input);
  });

  globalThis.document.body.appendChild(form);
  form.submit();
};
